import classNames from "classnames";
import SquareImageLeftTitle from "src/components/articledisplays/SquareImageLeftTitle";
import { ArticleBlockSponsorProps } from "src/components/forsiden/ArticleBlockV2";
import TopOfPageSponsor from "src/components/takoversponsor/TopOfPageSponsor";
import { GroupedLayoutObject, IMostReadNews, IVerticalArticleList } from "src/lib/types/IForsidenV2";
import styles from './VerticalArticleList.module.css';

//#region [Props]
type VerticalArticleListProps = {
    block: GroupedLayoutObject<IVerticalArticleList | IMostReadNews>;
    className?: string
} & ArticleBlockSponsorProps;
//#endregion

//#region [Component]
export default function VerticalArticleList({ block, className, sponsorClickUrl, sponsorTopImageDesktop, sponsorTopImageMobile }: VerticalArticleListProps) {
    const hasTopSponsor = !!sponsorTopImageDesktop;
    return <section className={classNames(className)}>
        <header className={classNames(styles.SListHeader)}>
            <h2>{block.label}</h2>
            {hasTopSponsor && <TopOfPageSponsor className={classNames(styles.STopOfPageSponsor)} clickUrl={sponsorClickUrl} desktopImages={sponsorTopImageDesktop} />}
        </header>
        <div className={classNames(styles.SList, styles[block.themes ?? 'dark'], { [styles.withSeparators]: block.showSeparators })}>
            {block.articles?.map((doc) => <SquareImageLeftTitle key={doc._id} document={doc} themeValue={block.themes} showSeparator={block.showSeparators} useSectionTitle />)}
        </div>
    </section>;
}
//#endregion

//#region [Styles]
//#endregion
